module.exports = __webpack_public_path__ + "static/media/more.3cad0ea5.svg";